import { Category, YSH_GTM_EVENTS } from '../types/types';
import { Link, useSearchParams } from 'react-router-dom';
import { pushToAnalytics } from '../utils/analytics';
import { APP_BASE } from '../constants/config';
import Sheet from 'react-modal-sheet';
import CategoryList from './CategoryList';
import close from '../assets/images/icons/icon-close.svg';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import '../scss/category-box.scss';

interface Props {
  category?: Category;
  isDefault?: boolean;
}

const CategoryBox: React.FC<Props> = ({ category, isDefault }) => {
  const hasAppBase = APP_BASE !== '/';
  const [searchParams, setSearchParams] = useSearchParams();
  const isModalOpen =
    searchParams.get(SEARCH_PARAMS.SHOW_CATEGORIES_MODAL) === 'true';

  const handleClickSpecificCategory = () => {
    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.SELECT_COUPON_CATEGORY,
      data: { coupon_category: category?.name }
    });
  };

  const handleCloseModal = () => {
    searchParams.delete(SEARCH_PARAMS.SHOW_CATEGORIES_MODAL);
    setSearchParams(searchParams);
  };

  const handleClickAllCategories = () => {
    searchParams.set(SEARCH_PARAMS.SHOW_CATEGORIES_MODAL, 'true');
    setSearchParams(searchParams);

    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.SELECT_COUPON_CATEGORY,
      data: { coupon_category: 'Sve kategorije' }
    });
  };

  return (
    <>
      {isDefault && (
        <div
          className="category-box-wrapper"
          onClick={handleClickAllCategories}
        >
          <div className="category-box">
            <div className="category-box__icon">
              <img
                width={30}
                height={30}
                src={`${hasAppBase ? APP_BASE : ''}/categories/all.png`}
                alt="slika koja predstavlja sve kategorije"
              />
            </div>
          </div>
          <h3 className="category-box__text font-yettel fz-15 mt-2">
            Sve kategorije
          </h3>
        </div>
      )}

      {!isDefault && (
        <Link
          className="category-box-wrapper"
          to={`/ponude?category=${category?.id}`}
          onClick={handleClickSpecificCategory}
        >
          <div className="category-box">
            <div className="category-box__icon">
              {category?.icon && (
                <img
                  width={40}
                  height={40}
                  src={`${hasAppBase ? APP_BASE : ''}/categories/${category?.icon}.png`}
                  alt="slika kategorije"
                />
              )}
            </div>
          </div>
          <h3 className="category-box__text font-yettel fz-15 mt-2">
            {category?.name}
          </h3>
        </Link>
      )}

      {isDefault && (
        <Sheet isOpen={isModalOpen} onClose={() => handleCloseModal()}>
          <Sheet.Container>
            <Sheet.Header>
              <div className="d-flex justify-content-end pt-3 pe-3">
                <img
                  className="cursor-pointer"
                  width={25}
                  height={25}
                  src={close}
                  alt="close modal"
                  onClick={() => handleCloseModal()}
                />
              </div>
            </Sheet.Header>
            <Sheet.Content>
              <CategoryList />
            </Sheet.Content>
          </Sheet.Container>
          <Sheet.Backdrop onTap={() => handleCloseModal()} />
        </Sheet>
      )}
    </>
  );
};

export default CategoryBox;
